import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface SetDocumentVersionParams {
  documentId: string;
  version: string;
}

const setDocumentVersion: MutationFunction<
  SetDocumentVersionParams,
  SetDocumentVersionParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockVersioningOptions);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SetDocumentVersionParams>(
    `/documents/${args.documentId}`,
    {
      method: 'PUT',
      body: {
        versionIdentifier: args.version,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set document version');
};

export default setDocumentVersion;

const _mockVersioningOptions = {
  documentId: 'document-id',
  version: 'Initial',
};
